module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc7-64c2d7310ee359091201fb76f0785533.jpg";